<template>
  <div style="margin-left: 0px;">
    <div v-if="debug_show_page_name==true" style="color:green;">associated_device</div>
    <div :class="'container ' + pageContainerSize">
      <ag-grid-vue style="width: 100%; height: 100px" class="ag-blue" :gridOptions="gridOptions"></ag-grid-vue>
    </div>
    <div class="row " style="margin-top: 10px;">
      <div class=" col-xs-6" style="">
        <field-box   v-for="f in formFields.col1"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly"  :val="values[f.id]"></field-box>
      </div>
      <div class="col-xs-6" style="">
        <field-box   v-for="f in formFields.col2"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly"  :val="values[f.id]"></field-box>
      </div>
      <button
        v-if="hideNewBtn == false"
        :disabled="disableAllBtn || selected_row == Number.MAX_SAFE_INTEGER || disableNewBtn == true || read_only == false || checkUserPermission(true,permissionMode.ADD) == false"
        class="btn btn-primary"
        style="min-width: 100px;width: 232px;float: right;margin-right: 5px;background: #43c9de;border-color:#43c9de;" 
        @click="addNew"  >新規（ソフトウェア情報）</button>
      <button v-show ="isAdminSavingApplication == true"
      :disabled="disableAllBtn || checkUserPermission(true,permissionMode.EDIT) == false"
      v-if="readOnly == false" class="btn btn-primary" style="min-width:100px;width: 108px;float: right;margin-right: 10px;background: #43c9de;border-color:#43c9de;" @click="onSaveAssociatedDeviceConfirmdri" >上書登録</button>
      <button v-show ="isAdminSavingApplication == false"
      :disabled="disableAllBtn || checkUserPermission(true,permissionMode.EDIT) == false"
      v-if="readOnly == false"  class="btn btn-primary" style="min-width:100px;width: 108px;float: right;margin-right: 10px;background: #43c9de;border-color:#43c9de;" @click="onSaveAssociatedDeviceConfirm" >下書登録</button>
      <button v-if="read_only == false" class="btn btn-primary" style="min-width:100px;width: 109px;float: right;margin-right: 10px;background: #A6A6A6;border-color:#A6A6A6;" @click="btnCancel" >キャンセル</button>
      <button v-else
        v-show="hideEditBtn == false"
        :disabled="disableAllBtn || selected_row == -1  || disableEditBtn == true || checkUserPermission(true,permissionMode.EDIT) == false"
        class="btn btn-primary"
        style="min-width: 100px;width: 227px;float: right;margin-right: 10px;background: #43c9de;border-color:#43c9de;" 
        @click="onEdit" >編集（ソフトウェア情報）</button>
        <button
        :disabled="disableAllBtn || disableDelete || checkUserPermission(true,permissionMode.DELETE) == false"
        class="btn btn-primary" style="min-width:100px;width: 240px;float:right;margin-right: 7px;background: #ed791a;border-color:#ed791a;" @click="onDelete" >{{deleteText}}</button>
    </div>
    <information-modal tag="associatedDeviceAlertMessage"/>
    <confirmation-modal tag="deleteAssociatedDeviceModal" @done="onConfirmDelete" />
  </div>
</template>

<script>
import Vue from "vue";
import { AgGridVue } from "ag-grid-vue";
import { fields, filed_types } from "@/rules/fields_associated_device";
import { utils } from "@/libs/utils";
import fieldBoxes from '@/components/form-field';
import informationModal from '@/components/modals/information-modal';

import constants from '@/rules/constants';

import _debug from "debug";
var mdebug = _debug("esma:associated_device");
import acl from "@/rules/acl_rules";
import mixinPageCommon from "@/mixins/mixin_page_common";
import mixinDatasource from "@/mixins/mixin_datasource";
import { bus } from "@/libs/bus";

export default {
  mixins: [mixinPageCommon, mixinDatasource],
  components: {
    "ag-grid-vue": AgGridVue,
    'field-box': fieldBoxes,
    "information-modal":informationModal
  },
  data() {
    return {
      api_name: "associated_device",
      page_acl: acl.associated_device,
      detail_page_url: "/certificate_information_linked_devices/list/",
      state_current_editing:"current_editing2",
      state_current_row:"current_row2",
      state_is_editing_new:"is_editing_new2",
      state_last_filter_options:"last_filter_options2",
      local_fk_id:-1
    };
  },
  computed: {
     deleteText(){
      if(this.disableDelete || this.formOutputQty  == 0){
        return "削除（ソフトウェア情報）";
      }else{
        return "削除（ソフトウェア情報）(" + this.formOutputQty + ")";
      }
    },
    disableDelete(){
      if(this.formOutputQty > 0 && (Array.isArray(this.selectedRowArr) && this.selectedRowArr.length > 0) ){
        return typeof _.find(this.selectedRowArr,(d)=>{ return  Number(d.number_of_use) > 0 }) != "undefined";
      }else{
        if( isNaN(this.selected_row) == false && this.selected_row > -1
        && (this.numberOfUse == 0)){
          return this.read_only == false;
        }else{
          return true
        }
      }
    },
    numberOfUse(){
      return Number(_.get(this.$store.state,this.stateCurrentEditing+".number_of_use", _.get(this.$store.state,this.stateCurrentRow+".number_of_use",0)))
    },
    isAdminSavingApplication (){
      return this.isAdmin && this.loadBy == 'fk_id';
    },
    disableNewBtn(){
      return this.$props.disable_new_btn;
    },
    disableAllBtn(){
      return this.$props.disable_all_btn
    },
    disableEditBtn(){
      return this.$props.disable_edit_btn;
    },
    hideNewBtn(){
      return this.$props.hide_new_btn;
    },
    hideEditBtn(){
      return this.$props.hide_edit_btn;
    },
    Second:{
      get(){
        if(this.local_status === false){
          return this.$store.state[this.stateCurrentEditing]["second"] || "";
        }else{
          return this.local_status;
        }
       },
      set(v){
       this.$store.state[this.stateCurrentRow]["second"] = this.local_status = v;
       }
    },
    readOnly:{
      get(){
        return this.read_only;
      },
      set(v){
        this.read_only = v;
      }
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields() {
      return this.tabFieldList;
    },
    values() {
      console.log("values");
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      return [
        this.local_extend(fields.number_cert,{}),
        this.local_extend(fields.license_name,{}),
        this.local_extend(fields.software_name,{}),
        this.local_extend(fields.product_key,{}),
        this.local_extend(fields.upgrade,{}),
        this.local_extend(fields.number_of_upgrades,{}),
        this.local_extend(fields.unlimited,{}),
        this.local_extend(fields.license,{}),
        this.local_extend(fields.second,{}),
        this.local_extend(fields.second_number,{}),
        this.local_extend(fields.number_of_use,{}),
        this.local_extend(fields.the_number_of_remaining,{})
      ];
    },
    formFields() {
      return {
        col1:[
          this.local_extend(fields.license_name, {}),
          this.local_extend(fields.software_name, {}),
          this.local_extend(fields.product_key, {}),
          this.local_extend(fields.upgrade, {
              on_set_value:(data) =>{
              setTimeout(() => {
                bus.$emit("virtual_base_unit",{val: data == "有"})
              }, 100);
            }            
          }),
          this.local_extend(fields.number_of_upgrades, {
            disabled: false,
            required: true,
            field_style: " width: 100%;display: block;" ,
            listen_for: [
              {
                name: "virtual_base_unit",
                mode: "disable_and_clean_if_value",
                disable_if_value: true
              }
            ],
          }),
        ],
        col2:[
          this.local_extend(fields.unlimited, {
            on_set_value:(data) =>{
              setTimeout(() => {
                bus.$emit("upd_license_unlimited1",{val: data == "無制限"})
              }, 100);
              setTimeout(() => {
                bus.$emit("upd_license_unlimited2",{val: data == "無制限"})
              }, 110);
              setTimeout(() => {
                bus.$emit("upd_license_unlimited3",{val: data == "無制限"})
              }, 120);
            }
          }),
          this.local_extend(fields.second, {
            listen_for: [
              {
                name: "upd_license_unlimited2",
                mode: "disable_if_value",
                disable_if_value: false
              }
            ],
              on_set_value:(data) =>{
              setTimeout(() => {
                bus.$emit("upd_virtual_base_unit",{val: data == "有"})
              }, 100);
            }
          }),
          this.local_extend(fields.second_number, {
            disabled: false,
            required: true,
            field_style: " width: 100%;display: block;" ,
            listen_for: [
              {
                name: "upd_virtual_base_unit",
                mode: "disable_and_clean_if_value",
                disable_if_value: true
              }
            ],
          }),

          this.local_extend(fields.license, {
            listen_for: [
              {
                name: "upd_license_unlimited3",
                mode: "disable_if_value",
                disable_if_value: false
              }
            ],
          }),
          // this.local_extend(fields.certificate_management_number, {
          //   buttons: [
          //     {
          //         btn_style:"width:19%;margin-left:2px;padding-left: 1px;padding-right: 1px;float:right; margin-top: 2px;margin-bottom: 2px;",
          //         type:"callback",
          //         callback:(b)=>{
          //           this.yobikiPopUp()
          //         },
          //         label:"証書管理番号"// Need the spec.
          //     }
          // ]
          // }),
        ]
      }
    }
  },
  methods: {
    btnCancel() {
      this.commonValidateFieldsClear(this,()=>{})
      this.cancelCurrentSelection(true);
    },
    onDelete(){
      bus.$emit("deleteAssociatedDeviceModal",{
        title: "削除",
        message: "ソフトウェア情報の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color:"danger",
        no_color:"info",
        model_height:"50"
      });
    },
    onConfirmDelete(mode){
      if(mode == "yes"){
        if(Array.isArray(this.selectedRowArr) && this.selectedRowArr.length > 0){
          var arr = this.selectedRowArr.map((m)=>{return m.seq_id;})
          var vm = this
          this.commonDeleteArr(vm,arr,()=>{
            vm.reloadDataAfterDelete(vm);
          })
        }else{
          this.commonDelete(this, (err,result,vm)=>{
            vm.reloadDataAfterDelete(vm);
          });
        }
      }
    },
    reloadDataAfterDelete(vm){
      vm.gridOptions.api.purgeInfiniteCache();
      vm.countRows("onConfirmDelete");
      vm.$store.state[vm.stateCurrentRow] = {}
      vm.$store.state[vm.stateCurrentEditing] = {}
      vm.selected_row = -1;
      vm.selectedRowArr = []
    },
    local_extend(field_info,ext){
      ext.state_current_row = this.stateCurrentRow;
      ext.state_current_editing = this.stateCurrentEditing;
      return utils.extend(field_info,ext)
    },
    onSaveAssociatedDeviceConfirmdri(mode){
        this.readOnly = false;
        this.commonSaveInfo(this,this.api_name, {}, (err)=>{
          this.cancelCurrentSelection();
        });

    },
    numberOfUpgrades(){
      return Number(_.get(this.$store.state,this.stateCurrentEditing+".number_of_upgrades", _.get(this.$store.state,this.stateCurrentRow+".number_of_upgrades",0)))
    },
    numberOfLicenses(){
      return Number(_.get(this.$store.state,this.stateCurrentEditing+".license", _.get(this.$store.state,this.stateCurrentRow+".license",0)))
    },
    onSaveAssociatedDeviceConfirm(mode){
      this.commonValidateFields(this,{},(error_found)=>{
        if(error_found != false){
          return;
        }
        if(this.numberOfUpgrades() >= this.numberOfLicenses()){
          this.$notify({clear:true});
          this.$notify({
              title: "アップグレードの数が残数を超えているため、保存できません。",
              text: this.numberOfUpgrades() + " / " + this.numberOfLicenses(),
              type: "error",
              duration: 10000
            });
          return;
        }

        this.readOnly = false;
        this.commonSaveInfo(this,this.api_name, {}, (err)=>{
          if(err == null){
            this.$emit("data-saved",{})
          }
          this.cancelCurrentSelection();
        });
      });
    },
    onDetailsClick(ev, data) {
      var seq_id = false;
      if(typeof this.$route.params.seq_id != "undefined" && isNaN(this.$route.params.seq_id) == false){
        seq_id = this.$route.params.seq_id;
      }else if ( typeof this.local_fk_id != "undefined" && isNaN(this.local_fk_id) == false){
        seq_id = this.local_fk_id
      }
      if(seq_id != false){
        return this.$router.push( this.detail_page_url  + data.seq_id + "/" + seq_id);
      }
    },
    createColumnDefs() {
      var arr = this.defaultCreateColumn;
      _.find(arr,(a=>{return a.field == "seq_id"})).sort = null;
      var i = 0;
      this.tabFieldList.forEach(f => {
        var fi = {
          headerName: f.tab_label,
          field: f.id,
          width: f.tab_size || 10,
          tooltipField: f.id
        };
        if (f.cellRenderer) {
          fi.cellRenderer = f.cellRenderer;
        }
        if(fi.field == "number_cert"){
          fi.sort = "asc";
        }
        arr.push(fi);
      });

      [  utils.extend(this.fieldList.more_details, {tab_label:""}) ,this.fieldList.button_options].forEach(f => {
        var fi = {
          headerName: f.tab_label,
          sortable: false,
          field: f.id,
          width: 50,
          maxWidth: 50,
          pinned: 'right',
          cellRenderer: params => {
            if (params.column.colId == "more_details") {
              return this.createLocalGridTextButton(
                "機器",
                this.onDetailsClick,
                params.data
              );
            }
            if (params.column.colId == "button_options") {
              return this.createGridButton(
                "glyphicon glyphicon glyphicon-unchecked",
                "color: #5b9bd5;",
                this.onSelectedClickDatasource,
                params.data
              );
            }
          }
        };
        arr.push(fi);
      });
      return arr;
    },
    createLocalGridTextButton(text, onClick, row_data) {
      var center = document.createElement('center');
      var btn = document.createElement('button');
      // btn.style.cssText="padding: 0px 5px;margin-top:-2px;"
      btn.style.cssText="padding: 0px 5px;margin-top:-2px;" + ((this.disableAllBtn)?";background:#ccc;border:solid 1px #bbb;":"")
      btn.className = "btn btn-primary btn-xs"
      btn.innerHTML = ''+text+'';
      btn.addEventListener('click', (ev) => {
        if(this.disableAllBtn == false){
          onClick(ev, row_data)
        }
      });
      center.appendChild(btn)
      return center;
    },
     onRowSelected(ev) {
       this.$notify({clear:true});
      this.selected_row = ev.node.data.seq_id;
      this.commonOnRowSelected(this, ev, this.api_name,(vm)=>{
        if(ev.node.data.upgrade == '有' && ev.node.data.number_of_use != 0){
          this.$notify({
            title: "紐付されている機器が存在します。",
            text: "紐付を解除してください。",
            type: "error",
            duration: 10000
          });
          bus.$emit("associatedDeviceAlertMessage",{
            title: "",
            message: "紐付されている機器が存在します。<br>紐付を解除してください。",
            yes_label: "完了",
            large:false
          });
        }
      })
    },
    onEdit(){
      mdebug("onEdit")
      this.is_new  = false;
      setTimeout(() => {
        this.readOnly = false;
      }, 300);
    },
    addNew(){
      this.seq_id = "new";
      this.local_seq_id = Number.MAX_SAFE_INTEGER;
      this.selected_row = Number.MAX_SAFE_INTEGER;
      this.$store.state[this.stateCurrentRow] = {}
      this.$store.state[this.stateCurrentRow]= {
        seq_id : this.local_seq_id,
        ref_id : this.$props.ref_id,
        fk_id: this.local_fk_id,
        fk_tab: constants.TABLE_ID.CERTIFICATE_INFORMATION
      }
      this.$store.state[this.stateCurrentEditing] = {};
      this.$store.state[this.stateCurrentEditing]= {
        ref_id : this.$props.ref_id,
        fk_id: this.local_fk_id,
        fk_tab: constants.TABLE_ID.CERTIFICATE_INFORMATION
      }
      this.allFields.forEach(f =>{
        this.$store.state[this.stateCurrentRow][f.id] = "";
      })
      this.is_new = true;
      setTimeout(() => {
        this.$store.state[this.stateIsEditingNew] = true;
        this.read_only = false;
      }, 300);
    }
  },
  mounted() {
    this.gridOptions.api.sizeColumnsToFit();
    if(this.$route.params.seq_id == "new"){
      this.commonLoadRecord({},(err,result)=>{
        console.log("Load DeviceEmbeddedInformation else",this.$route.params.seq_id)
        if(this.$route.params.seq_id == "new"){
            this.Second = "無";

        }
        if(typeof this.$store.state[this.stateCurrentRow].approval_history_id == "number"){
          this.approvalHistoryId = this.$store.state[this.stateCurrentRow].approval_history_id
        }
        this.commonEditDeleteCmdHandler(this);
      })
    }
    // setTimeout(()=>{
    //   if(this.$props.fk_id && this.$props.fk_id > -1){
    //     this.searchControlChangedDatasource(this.singleSearchCreate("fk_id",""+this.$props.fk_id))
    //   }else{
    //     setTimeout(()=>{
    //         if(this.$props.fk_id && this.$props.fk_id > -1){
    //           this.searchControlChangedDatasource(this.singleSearchCreate("fk_id",""+this.$props.fk_id))
    //         }
    //     },1000)
    //   }
    // },100)
    if(this.$props.tag_reload && this.$props.tag_reload.length > 0){
      bus.$on(this.$props.tag_reload, (data) => {
        setTimeout(()=>{
          if(data.fk_id && isNaN(data.fk_id) == false && data.fk_id > 0){
            this.local_fk_id = data.fk_id 
            this.searchControlChangedDatasource(this.singleSearchCreate("fk_id","" + data.fk_id))
          }
        },10)
      })
    }
    },
  beforeDestroy() {
    if(this.$props.tag_reload && this.$props.tag_reload.length > 0){
      bus.$off(this.$props.tag_reload)
    }
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource({ load_only_with_filter:true});
  },
  props: {
    ref_id: { type: String, default: "" },
    fk_id: { type: Number, default: "" },
    tag_reload: { type: String, default: "" },
    disable_new_btn: { type: Boolean, default: false },
    disable_edit_btn: { type: Boolean, default: false },
    hide_new_btn: { type: Boolean, default: false },
    hide_edit_btn: { type: Boolean, default: false },
    disable_all_btn: { type: Boolean, default: false },
  },
};
</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// associated_device.vue?ebef5512